import api from "../../";
import type { UpdateSkyroomBody, PatchSkyroomParams } from "./types";

export const patchSkyroom = async ({ id, originalSkyroom, data }: PatchSkyroomParams): Promise<boolean> => {

  const body: UpdateSkyroomBody = {};

  if (data.name !== originalSkyroom.name) body.name = data.name;
  if (data.title !== originalSkyroom.title) body.title = data.title;
  if (data.guest_login !== originalSkyroom.guest_login) body.guest_login = data.guest_login;
  if (data.guest_limit !== originalSkyroom.guest_limit) body.guest_limit = data.guest_limit;
  if (data.op_login_first !== originalSkyroom.op_login_first) body.op_login_first = data.op_login_first;
  if (data.max_users !== originalSkyroom.max_users) body.max_users = data.max_users;

  if (!Object.keys(body).length) return false;

  return await api.patch(`/skyroom/${id}/`, body)
  .then(() => true).
  catch(() => false);
};
